import { BaseProtoUuidDto } from './base-proto-uuid.dto';

/**
 * Proto DTO identity for records that have both a numeric PK and a uuid.
 */
export abstract class BaseProtoDto extends BaseProtoUuidDto {
  id!: number;
}
